/* eslint-disable prettier/prettier */
export const IMPORT_ORDER_DATA = "IMPORT_ORDER_DATA";
export const SET_SELECTED_DATA = "SET_SELECTED_DATA";
export const SET_SINGLE_ORDER_DATA = "SET_SINGLE_ORDER_DATA";
export const FETCH_ORDERS_DATA = "FETCH_ORDERS_DATA";
export const FETCH_ORDERS_SUMMARY = "FETCH_ORDERS_SUMMARY";
export const FILTER_ORDER_LIST = "FILTER_ORDER_LIST";
export const FETCH_ORDER_DETAILS = "FETCH_ORDER_DETAILS ";
export const LIST_LOADING = "LIST_LOADING"
export const DETAILS_LOADING = "DETAILS_LOADING"
export const DETAILS_INPUT = "DETAILS_INPUT"
export const UPDATE_ORDER_DETAILS = "UPDATE_ORDER_DETAILS"
export const FETCH_ORDER_NOTES = 'FETCH_ORDER_NOTES'
export const ORDER_NOTE_INPUT = 'ORDER_NOTE_INPUT'
export const RESET_ORDER_NOTE_INPUT = 'RESET_ORDER_NOTE_INPUT'
export const NOTES_LOADING = 'NOTES_LOADING'
export const NEW_ORDER_NOTE = 'NEW_ORDER_NOTE'
export const ORDER_NOTE_STATUS_MSG = 'ORDER_NOTE_STATUS_MSG'
export const DELETE_ORDER_NOTE = 'DELETE_ORDER_NOTE'
export const ORDER_TRACKING_INPUT = 'ORDER_TRACKING_INPUT'
export const ORDER_TRACKING_INPUT_RESET = 'ORDER_TRACKING_INPUT_RESET'